import React, { useCallback, useRef, useState } from 'react'
import CreateMixtureForm from '../Forms/CreateMixtureForm';
import { toast } from 'react-toastify';
import { PlusIcon } from '@heroicons/react/16/solid';
import TableHeaderButton from '../../Common/DaisyTable/TableHeaderButton/TableHeaderButton';
import { TrashIcon, ShoppingCartIcon } from '@heroicons/react/24/outline';
import DeleteMultipleMixturesModal from './DeleteMultipleMixturesModal/DeleteMultipleMixturesModal';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { ROLES } from '../../../utils/roles.utils';
import PortalModal from '../../Common/Modal/PortalModal';

const MixturesHeaderActions = ({ setTableData, table, type }) => {
  const { user } = useAuth()
  const createModalRef = useRef(null);
  const deleteModalRef = useRef(null);
  const [selectedRows, setSelectedRows] = useState([])
  const navigate = useNavigate();

  const handleShowCreateModal = useCallback(() => {
    if (createModalRef.current) {
      createModalRef.current.showModal();
    } else {
      console.warn('createModalRef is not available');
    }
  }, [createModalRef]);
  const handleShowDeleteModal = () => {
    if (deleteModalRef.current) {
      const selectedIds = table.getState().rowSelection
      console.log(selectedIds)
      const rows = table.options.meta?.getRowsByIds(selectedIds);
      console.log(rows)

      if (!rows || rows.length === 0) {
        return toast.warning('Veuillez sélectionner un/des mélanges', { autoClose: 800 });
      }

      setSelectedRows(rows);
      deleteModalRef.current.showModal();
    } else {
      setSelectedRows([]);
      console.warn('deleteModalRef is not available');
    }
  }

  const handleUpdateTable = async (selectedIds) => {
    table.options.meta?.removeBatchRows(selectedIds, true);
    table.resetRowSelection();
    setSelectedRows([]);
  }

  const handleOrderSelected = () => {
    const selectedIds = table.getState().rowSelection;
    const rows = table.options.meta?.getRowsByIds(selectedIds);

    if (!rows || rows.length === 0) {
      toast.warning('Veuillez sélectionner au moins un mélange', { autoClose: 2000 });
      return;
    }
    // Récupérer les données des mélanges sélectionnés pour les passer à la page de commande
    const selectedMixtures = rows.map(row => {
      return {
        id: row.id,
        name: row.name,
        dilution: row.defaultDilution.label,
        subCategory: row.subCategory,
        category: row.category,
        reagents: row.reagents.join(', ')
      };
    });

    // Rediriger vers la page de commande avec les mélanges sélectionnés
    navigate('/commander-selection', {
      state: { selectedMixtures }
    });
  };

  return (
    <>
      <div className="w-full flex m-auto items-center justify-between px-4 py-2 h-fit mb-4 border-x-0 border-t-0 border-container">
        <div className="flex gap-2">
          {window.location.pathname.includes('catalogue') && user?.permission?.label === ROLES.ADMIN.label &&
            <TableHeaderButton className={'btn-primary'} Icon={<PlusIcon className='h-5 w-5' />} text="Nouveau Mélange" onClick={handleShowCreateModal} />
          }
          {window.location.pathname.includes('catalogue') && user?.permission?.label === ROLES.ADMIN.label &&
            <TableHeaderButton className={'btn-warning'} Icon={<TrashIcon className='h-5 w-5' />} text="Supprimer la sélection" onClick={handleShowDeleteModal} />
          }
          {window.location.pathname.includes('personnalises') &&
            <TableHeaderButton className={'btn-primary'} Icon={<PlusIcon className='h-5 w-5' />} text="Nouveau Mélange" onClick={handleShowCreateModal} />
          }
          {window.location.pathname.includes('personnalises') &&
            <TableHeaderButton className={'btn-warning'} Icon={<TrashIcon className='h-5 w-5' />} text="Supprimer la sélection" onClick={handleShowDeleteModal} />
          }
        </div>

        <button
          onClick={handleOrderSelected}
          className="btn btn-primary btn-sm flex items-center gap-2"
        >
          <ShoppingCartIcon className="h-4 w-4" />
          Commander la sélection
        </button>
      </div>

      {/* Modal pour la création de mélange */}
      <PortalModal ref={createModalRef} size='2xl' className='p-0'>
        <div className='p-6'>
          <div className='flex items-center gap-3 mb-4 border-b pb-4'>
            <div className='bg-primary/10 p-2 rounded-full'>
              <PlusIcon className='h-6 w-6 text-primary' />
            </div>
            <h2 className='text-lg font-bold text-primary'>Nouveau mélange</h2>
          </div>
          <CreateMixtureForm setTableData={setTableData} onCloseModal={() => createModalRef.current.hideModal()} />
        </div>
      </PortalModal>

      {/* Modal pour la suppression de mélanges */}
      <DeleteMultipleMixturesModal
        type={type}
        ref={deleteModalRef}
        mixtures={selectedRows}
        updateTable={handleUpdateTable}

      />
    </>
  )
}

export default MixturesHeaderActions
